// import axios from "axios";
import secure_axios from "../../services/secure_axios";

const initialState = () =>( {
  alljournals: [],
});
const state = initialState();

const getters = {
  alljournals: (state) => state.alljournals,
};

const mutations = {
  setAllJournals(state, payload) {
    state.alljournals = payload;
  },
  clearJournals(state) {
    state.alljournals = [];
  },
  RESET_STATE(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

const actions = {
  getAllJournals({ commit, getters }, payload) {
    commit("setLoading", true);
    commit("clearError");

    const acdoctype = payload.acdoctype;
    const acdocno = payload.acdocno;

    secure_axios
      .get(`${getters.sessionAPI}journals?acdoctype=${acdoctype}&acdocno=${acdocno}`)
      .then((response) => {
        commit("setAllJournals", response.data.journals);
        commit("setLoading", false);
      })
      .catch((error) => {
        commit("setLoading", false);
        commit("setError", error);
      });
  },
  clearAllJournals({ commit }) {
    commit("clearJournals");
  },
};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
};
